import React from 'react'
import type { BundleCategoryTab } from '@/types'
import { cn } from '@/lib/utils'
import useLocalizedValue from '@/hooks/use-localized-value'
import { LazySvg } from '../lazy-svg'

interface BundleCategoryTabProps {
  categories: BundleCategoryTab[]
  activeCategory: string
  onCategoryChange: (categoryId: string) => void
}

const BundleCategoryTab: React.FC<BundleCategoryTabProps> = React.memo(
  ({ categories, activeCategory, onCategoryChange }) => {
    return (
      <div className="flex flex-col space-y-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={cn(
              'flex items-center justify-start space-x-1 rounded-xl p-3 font-medium transition-colors rtl:space-x-reverse rtl:font-semibold',
              activeCategory === category.id
                ? 'cursor-default bg-primary text-primary-foreground'
                : 'bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground'
            )}
            dir="auto"
          >
            <LazySvg name="/icons/validity.svg" className="size-5" />
            <span>{useLocalizedValue(category.name)}</span>
          </button>
        ))}
      </div>
    )
  }
)

BundleCategoryTab.displayName = 'BundleCategoryTab'

export default BundleCategoryTab
